import React from 'react';
import { Phone } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-gradient-to-br from-[#0D7377] to-[#14919B] text-white py-20 overflow-hidden" data-id="element-262">
      <div className="absolute inset-0 opacity-10" data-id="element-263">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')]" data-id="element-264"></div>
      </div>
      <div className="max-w-7xl mx-auto px-4 relative z-10" data-id="element-265">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-266">
          <div data-id="element-267">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight" data-id="element-268">
              Fast, Reliable Appliance Repairs Across the UK
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-100" data-id="element-269">
              Qualified engineers. Clear pricing. Quick bookings.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-270">
              <a href="tel:08000554969" className="bg-[#E8956B] text-white px-8 py-4 rounded-full font-semibold hover:bg-[#D67D54] transition-all shadow-lg hover:shadow-xl text-center text-lg" data-id="element-271">
                Book a Repair
              </a>
              <a href="tel:08000554969" className="bg-white text-[#0D7377] px-8 py-4 rounded-full font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl text-center text-lg flex items-center justify-center gap-2" data-id="element-272">
                <Phone size={20} data-id="element-273" />
                Request a Callout
              </a>
            </div>
          </div>
          <div className="relative" data-id="element-274">
            <div className="rounded-2xl overflow-hidden shadow-2xl" data-id="element-275">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/otYoFqGGxbUaaa7GjqgYjK/01._Footer.png" alt="Happy family in modern kitchen with appliances - professional repair service" className="w-full h-auto" data-id="element-276" />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white text-[#0D7377] p-6 rounded-xl shadow-xl hidden md:block" data-id="element-277">
              <div className="text-4xl font-bold" data-id="element-278">500+</div>
              <div className="text-sm font-medium" data-id="element-279">Repairs Completed</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}